var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "135px",
    height: "35px",
    viewBox: "0 0 100 25.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f{fill:#fff000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "d",
    className: "f",
    y: 17.88,
    width: 100,
    height: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.04,4.92c0,1.29-.51,1.62-1.76,1.62h-1.78V3.43h1.8c1.31,0,1.74,.34,1.74,1.49h0Zm4.45-.16c0-3.03-2.12-4.5-6.12-4.5h-6.12V13.88h4.25v-4.49h1.76l2.31,4.49h5.01l-3.49-5.3c1.53-.54,2.4-2.05,2.4-3.81h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.73 10.52 77.73 8.45 83.27 8.45 83.27 5.47 77.73 5.47 77.73 3.65 84.43 3.65 84.36 .25 73.48 .25 73.48 13.88 84.63 13.88 84.7 10.52 77.73 10.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.92 13.88 70.92 .25 66.69 .25 66.69 5.29 62.16 5.29 62.16 .25 57.91 .25 57.91 13.88 62.16 13.88 62.16 8.76 66.69 8.76 66.69 13.88 70.92 13.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.94,.56c-.98-.33-2.38-.56-3.67-.56-5.23,0-7.56,2.71-7.56,7.01,0,4.65,2.47,7.12,7.19,7.12,1.4,0,2.92-.33,4.07-.84l-.45-3.12c-.87,.34-1.93,.56-3.05,.56-2.6,0-3.27-.89-3.27-3.71,0-2.67,.62-3.56,3.23-3.56,1.22,0,2.23,.18,3.09,.42l.42-3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.46,4.92c0,1.29-.51,1.62-1.76,1.62h-1.78V3.43h1.8c1.31,0,1.74,.34,1.74,1.49h0Zm4.45-.16c0-3.03-2.12-4.5-6.12-4.5h-6.12V13.88h4.25v-4.49h1.76l2.31,4.49h5.01l-3.49-5.3c1.53-.54,2.4-2.05,2.4-3.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.44,8.43h-3.12l1.14-3.56,.42-1.42h.05l.4,1.42,1.11,3.56Zm6.47,5.45L24.38,.25h-4.92l-5.41,13.62h4.52l.73-2.29h5.12l.71,2.29h4.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.42,
    y: 0.25,
    width: 3.16,
    height: 2.89
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.28,
    y: 0.25,
    width: 3.16,
    height: 2.89
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.9 .25 5.61 5.36 4.25 5.36 4.25 .25 0 .25 0 13.88 4.25 13.88 4.25 8.56 5.56 8.56 8.86 13.88 14.04 13.88 9.34 6.7 13.79 .25 8.9 .25"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.f74e94ff66ad3bc93321643c38f0418e.svg";
export { ForwardRef as ReactComponent };